import { randomStageSound } from './JSPlaceholder';
import { useDispatch, useSelector } from 'react-redux';
import { incrementStageIndex } from './redux/stageIndex';
import { deactivateStage } from './redux/stageList';
import { enableButton, disableAllButtons } from './redux/buttonstatus';
import { setStageLabel } from './redux/runDisplay';
import { playRandomAudio, stageSelectionClips } from './AudioClips';
import {
  spinWheel,
  WHEEL_SELECTION_TIMINGS,
} from './wheelAnimation';

const PickStage = () => {
  const stageListData = useSelector((state) => state.stageList.stageListData);
  const stageIndex = useSelector((state) => state.stageIndex.stageIndexCount);
  const stageButtonStatus = useSelector(
    (state) => state.buttonStatus.stageButton,
  );
  const dispatch = useDispatch();

  const activeStages = stageListData
    .filter((stage) => stage.isActive)
    .map((stage) => stage.stage);

  const handleStageSelection = () => {
    // Play Music
    playRandomAudio(stageSelectionClips);
    // console.log(activeStages);
    let headerStages = document.getElementById('headerStages');
    dispatch(disableAllButtons());
    randomStageSound();

    // Handler for each spin step - not used for stages but included for consistency
    const onSpinStep = () => {
      // Optional: Can add visual feedback here if needed
    };

    // Handler for when the spin completes and a stage is selected
    const onSelect = (finalStageName) => {
      // Update the stage display in the correct slot
      let stage = document.getElementById(stageIndex);
      stage.textContent = finalStageName;
      dispatch(
        setStageLabel({
          slotId: stageIndex,
          label: finalStageName,
        }),
      );

      // Remove the selected stage from future selections
      for (let i = 0; i < stageListData.length; i++) {
        if (stageListData[i].stage === finalStageName) {
          dispatch(deactivateStage({ stageId: i }));
          break;
        }
      }

      // Advance to next stage index if available
      if (stageIndex < 13) {
        dispatch(incrementStageIndex());
      }

      // Enable buttons for next selection
      dispatch(enableButton({ buttonId: 'characterButton' }));
      dispatch(enableButton({ buttonId: 'removeStageButton' }));
    };

    // Start the wheel spin animation
    spinWheel(
      headerStages,
      activeStages,
      WHEEL_SELECTION_TIMINGS,
      onSpinStep,
      onSelect,
    );
  };

  return (
    <div>
      <header>Stage Picker</header>
      <div className='wheel-display' aria-live='polite'>
        <span id='headerStages'>?</span>
      </div>
      <button
        onClick={handleStageSelection}
        disabled={stageButtonStatus === 'disabled'}
        className='button'
        id='stageButton'
      >
        Start
      </button>
    </div>
  );
};
export default PickStage;
